import { jsx as _jsx } from "react/jsx-runtime";
import { Refresh as RefreshIcon } from "@air/next-icons";
import classNames from "classnames";
import { memo } from "react";
import { THUMBNAIL_HEIGHT } from "../../../shared/constants";
export const ProcessingVersionThumbnail = /*#__PURE__*/ memo((param)=>{
    let { isCurrentVersion } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("asset-modal-version-thumbnail pointer-events-none box-border flex w-full items-center justify-center overflow-hidden rounded-sm border border-black bg-pigeon-800"),
        style: {
            height: THUMBNAIL_HEIGHT,
            // @TODO: use theme colors
            boxShadow: isCurrentVersion ? "0px 0px 0px 2px #CECECE" : undefined
        },
        children: /*#__PURE__*/ _jsx(RefreshIcon, {
            className: "size-8 animate-spin fill-pigeon-300"
        })
    });
});
ProcessingVersionThumbnail.displayName = "ProcessingVersionThumbnail";
